import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-device-modal',
    templateUrl: './edit-device-modal.component.html',
    styleUrls: ['./edit-device-modal.component.scss'],
    imports: [ReactiveFormsModule, TranslatePipe]
})
export class EditDeviceModalComponent implements OnInit {
  @Output() updateName = new EventEmitter();
  deviceName: string;
  deviceNameForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.deviceNameForm = this.fb.group({
      deviceName: [this.deviceName, [Validators.required]]
    });
  }

  edit() {
    if (
      this.deviceNameForm.valid &&
      this.deviceNameForm?.get('deviceName')?.value
    ) {
      this.updateName.emit(
        this.deviceNameForm!.get('deviceName')!.value as string
      );
      this.activeModal.close();
    }
  }
}
